import { render } from "./IntroductionIES3.vue?vue&type=template&id=6dd20478&scoped=true"
import script from "./IntroductionIES3.vue?vue&type=script&lang=js"
export * from "./IntroductionIES3.vue?vue&type=script&lang=js"

import "./IntroductionIES3.vue?vue&type=style&index=0&id=6dd20478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd20478"]])

export default __exports__